/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { SequenceFeatureColor } from './SequenceFeatureColor';
import {
    SequenceFeatureColorFromJSON,
    SequenceFeatureColorFromJSONTyped,
    SequenceFeatureColorToJSON,
} from './SequenceFeatureColor';

/**
 * 
 * @export
 * @interface SequenceFeatureColorsResponse
 */
export interface SequenceFeatureColorsResponse {
    /**
     * 
     * @type {Array<Message>}
     * @memberof SequenceFeatureColorsResponse
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {Array<SequenceFeatureColor>}
     * @memberof SequenceFeatureColorsResponse
     */
    payload?: Array<SequenceFeatureColor>;
}

/**
 * Check if a given object implements the SequenceFeatureColorsResponse interface.
 */
export function instanceOfSequenceFeatureColorsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SequenceFeatureColorsResponseFromJSON(json: any): SequenceFeatureColorsResponse {
    return SequenceFeatureColorsResponseFromJSONTyped(json, false);
}

export function SequenceFeatureColorsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceFeatureColorsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messages': !exists(json, 'messages') ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : ((json['payload'] as Array<any>).map(SequenceFeatureColorFromJSON)),
    };
}

export function SequenceFeatureColorsResponseToJSON(value?: SequenceFeatureColorsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': value.payload === undefined ? undefined : ((value.payload as Array<any>).map(SequenceFeatureColorToJSON)),
    };
}

